import React from 'react'

import NewProjectType from './NewProjectType'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const NewProjectTypePage = () => (
  <section>
    <header>
      <PageTitle>New project type</PageTitle>
    </header>
    <NewProjectType showSuccessDialog={true} />
    <br />
    <BackButton />
  </section>
)

export default NewProjectTypePage



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/NewProjectTypePage.jsx